// extracted by mini-css-extract-plugin
export var adjacentSlide = "_jh-9";
export var arrowButtonContainer = "_jh-5";
export var arrowButtonIcon = "_jh-6";
export var carouselArrowButton = "_jh-2";
export var carouselElementContainer = "_jh-1";
export var currentSlide = "_jh-8";
export var left = "_jh-3";
export var otherSlide = "_jh-a";
export var productCarouselContainer = "_jh-0";
export var right = "_jh-4";
export var sliderOverflow = "_jh-7";